const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();

// ------------------------------------------------------------------------
// anchorLink
// ------------------------------------------------------------------------
// const anchorLink = () => {
//   $("a[href^='#']").on("click", function(){
//     let linkSpeed    = 800;
//     let linkHref     = $(this).attr("href");
//     let linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
//     let linkAdjust   = 0;
//     let linkPosition = linkTarget.offset().top;
//     return false;
//   });
// };


// ------------------------------------------------------------------------
// preload
// ------------------------------------------------------------------------
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};


// ------------------------------------------------------------------------
// tabletToggle
// ------------------------------------------------------------------------
const tabletToggle = () => {
  $(window).on("load", function(){
    if (/iPad|Macintosh/i.test(navigator.userAgent)&& 'ontouchend' in document || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1)) {
      $(".pc_f.entry-cta_button").addClass("tablet");
      $(".sp_f.entry-cta_button").addClass("tablet");
      $(".text-small.text-center.text-med.sp_b").removeClass("sp_b");
    }
  });
};


// ------------------------------------------------------------------------
// loadAnime
// ------------------------------------------------------------------------
const loadAnime = () => {
  $(window).on('load', function() {
    $('.ld-anim').each(function() {
      const target = $(this);
      $(this).addClass("animated");
    });
  });
};

// ------------------------------------------------------------------------
// accordionToggle
// ------------------------------------------------------------------------
const accordionToggle = () => {
  $(".accordion-toggle").on("click", function() {
    $(this).toggleClass("open");
    $(this).next().toggleClass("open");
    $(this).next().slideToggle(300);
  });
};



// ------------------------------------------------------------------------
// initScrollbar
// SP/タブレット時（デフォルトでオーバーレイスクロールがある場合）は無効
// ------------------------------------------------------------------------
function togglescrllUI(scrollpos) {
  if($(".idx-Mv").length == true) {
    let mvHeight = $(".idx-Mv_Inner").outerHeight();
    if (scrollpos > mvHeight){
      $(".header-hamburger").addClass("scrolled");
    } else {
      $(".header-hamburger").removeClass("scrolled");
    }
  }
  if (scrollpos > 500){
    $(".st-Pagetop").addClass("scrolled");
  } else {
    $(".st-Pagetop").removeClass("scrolled");
  }
}
function togglescrllAnim(scrollpos) {
  $('.sc-anim').each(function() {
    let targetElm = $(this);
    let targetPos = targetElm.position().top;
    let windowHeight = $(window).height();
    if (scrollpos > targetPos - windowHeight + windowHeight / 6) {
      targetElm.addClass("animated");
    }
  });
}

const initScrollbar = () => {
  let instance = $("body").overlayScrollbars({
    scrollbars : {
      autoHide: "move",
    },
    nativeScrollbarsOverlaid: {
      initialize: false,
    },
    callbacks: {
      onScroll: function(e) {
        const scrollPos = e.target.scrollTop;

        togglescrllAnim(scrollPos);
        togglescrllUI(scrollPos);
      }
   }
  }).overlayScrollbars();

  // その他スクロール系処理
  let scrllValid = OverlayScrollbars.valid(instance);
  $("a[href^='#']").on("click", function(){
    const linkSpeed    = 800;
    let linkHref     = $(this).attr("href");
    let linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    if(scrllValid) {
      const linkAdjust   = 0;
      let linkPosition = linkTarget.position().top;
      instance.scroll({ y : linkPosition - linkAdjust }, 800, {y : "swing" });
    } else {
      const linkAdjust   = 40 * (windowWidth / 768);
      let linkPosition = linkTarget.offset().top;
      $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    }
    return false;
  });
  $(window).on("load scroll", function() {
    let scrollPos = $(window).scrollTop();

    togglescrllAnim(scrollPos);
    togglescrllUI(scrollPos);
  });
};



// ------------------------------------------------------------------------
// toggleMenu
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.header-hamburger').on('click', function() {
    $(this).toggleClass("open");
    $(".header-nav").toggleClass("open");
  });
};



// ------------------------------------------------------------------------
// resizeHeader
// ------------------------------------------------------------------------
const resizeHeader = () => {
  $(window).on("load scroll", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".header-hamburger").addClass("scrolled");
    } else {
      $(".header-hamburger").removeClass("scrolled");
    }
  });
};



// ------------------------------------------------------------------------
// tableScroll
// ------------------------------------------------------------------------
const tableScroll = () => {
  $(window).on("load resize", function() {
    if($(".outline-schedule_wrap").length == true) {
      let instance = $(".outline-schedule_wrap, .outline-schedule_wrap_team").overlayScrollbars({
        scrollbars : {
          },
      }).overlayScrollbars();
    }
  });
};



export {
  preload,
  tabletToggle,
  loadAnime,
  initScrollbar,
  accordionToggle,
  toggleMenu,
  tableScroll
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js